<template>
    <v-dialog v-model="alertShown" max-width="470">
        <v-card>
            <v-card-title class="grey lighten pa-5" style="color: white;"><i style="color: #e53f2c;" class="b-fa b-fa-exclamation-triangle"></i>&nbsp;&nbsp;Delete all marked Events</v-card-title>

            <v-card-text class="pa-5" style="font-size: 1.2rem; font-weight: 400;">
                You want to continue and delete all?

                <div style="marginTop: 16px">
                    <p style="font-size: 1.0rem; font-weight: 600; margin: 0; display: inline;" v-for="(date, index) in selectedDates" :key="date.date">
                        {{ formateDate(date.date) }}{{ index !== selectedDates.length - 1 ? ";&nbsp;&nbsp;" : " " }}
                    </p>
                </div>
            </v-card-text>

            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" outlined color="#ab3b7a" @click="() => alertShown = false">Disagree</v-btn>
                <v-btn style="width:120px; font-size:12px;" depressed elevation="1" color="primary" @click="onClick_deleteVacations">Agree</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

</template>


<script>
    import { mapActions } from 'vuex';
    import { eventBus } from '../../../../../main';

    import dayjs from "dayjs";


    export default {
        name: 'DeleteAlert',

        /* >>> *************************************************************** / /* Props */
        props: {

            value : [ Boolean ],
            selectedDates : Array

		}, // eo props{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Data */
		data: function() {

			return {};

        }, // eo funtion data()
		/* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            /*******************************************************************
            * alertShown{}
            *
            * Desc:
            * Note:
            *
            */
            alertShown: {

                get() {

                    const me = this;


                    me.$toc('>>> views/hotels/components/core/DeleteAlert.vue >>> computed/alertShown/get');

                    return this.value;

                }, // eo function alertShown get()

                set(value) {

                    const me = this;


                    me.$toc('>>> views/hotels/components/core/BottomSheet.vue >>> computed/alertShown/set');
                    this.$emit('input', value);

                }, // eo function alertShown set()

            }, // eo alertShown{}

        }, // eo computed{}
		/* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Methods */
		methods: {

            ...mapActions([
                'actn_call_deleteVacations',
                'actn_call_deleteMultiVacations'
            ]),


            /*******************************************************************
            * formateDate()
            *
            * Desc:
            * Note:
            *
            */
            formateDate: function(date) {

                return dayjs(date).format("D. MMMM YYYY")

            }, // eof formateDate()


            /*******************************************************************
            * buildDeleteMutipleVacationsPayload()
            *
            * Desc:
            * Note:
            *
            */
            buildDeleteMutipleVacationsPayload: function(selectedDates) {

                return {
                    idBreaks: selectedDates.map(d => d.id),
                    idProceedings: [],
                    idStays: [],
                    idTrainings: []
                }

            }, // eo function buildDeleteMutipleVacationsPayload()


            /******************************************************************* 'Listeners - Common'
            * Listeners:
            *******************************************************************/
            /*******************************************************************
            * onClick_deleteVacations()
            *
            * Desc:
            * Note:
            *
            */
            onClick_deleteVacations: async function() {

                const me = this;


				me.$toc('>>> views/hotels/Home.vue >>> onClick_deleteVacations');
                if (me.selectedDates.length > 1) {
                    me.actn_call_deleteMultiVacations(me.buildDeleteMutipleVacationsPayload(me.selectedDates));
                } else {
                    me.actn_call_deleteVacations(me.selectedDates[0].id);
                }
                eventBus.$emit('deleteVacationsDone');
				me.alertShown = false;

            }, // eo function onClick_deleteVacations()


            /*******************************************************************
            * onClick_CloseSheet()
            *
            * Desc:
            * Note:
            *
            */
			onClick_CloseSheet: function() {

                const me = this;


				me.$toc('>>> views/hotels/Home.vue >>> onClick_CloseSheet');
				this.alertShown = false;

            }, // eo function onClick_CloseSheet()


        } // eo methods{}
		/* <<< ****************************************************************/

    };
</script>

<style scoped>
    .v-dialog > .v-card > .v-card__actions {
        padding: 10px 10px;
    }

    .v-card__subtitle, .v-card__text {
        font-size: 1rem;
        font-weight: 500;
        line-height: 1.375rem;
        letter-spacing: 0.0071428571em;
    }

    .v-stepper__content {
        max-height:700px;
        overflow-y:scroll;
    }

    .v-stepper__content h2 {
        font-weight:500;
        margin-top:24px;
        font-size: 1.2em;
    }

    .v-stepper__content .input-row:not(:first-child) {
        border-top:1px solid lightgrey;
        margin-top:24px;
    }
</style>